import React, { useState } from 'react';
import { Plus, Minus, ArrowRight } from 'lucide-react';
import { services } from '../mock';

const WhyStand = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="about" className="relative py-24 lg:py-32 bg-white overflow-hidden border-t border-black/5">
      <div className="brush-swash w-72 h-16 top-20 right-0" />

      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <div className="aspect-[4/5] rounded-[2rem] overflow-hidden relative shadow-lg">
              <img
                src="https://images.pexels.com/photos/7951932/pexels-photo-7951932.jpeg?w=800"
                alt="Community members together"
                className="w-full h-full object-cover"
              />
              <div className="absolute -top-6 -left-4 w-40 h-16 bg-[#F1D3B6] rounded-[50%] -rotate-12 -z-0 opacity-70" />
            </div>
            <div className="mt-6 bg-white rounded-2xl p-6 border-l-4 border-[#6e12ed] shadow-sm">
              <div className="font-serif text-3xl font-bold text-[#6e12ed]">Since 1987</div>
              <div className="text-sm text-neutral-700 mt-1 leading-snug">
                Founded by the Wolverhampton Rastafarian Progressive Association to respond to the
                disproportionate admissions of people of African descent into acute psychiatric hospitals.
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-neutral-500 mb-4">
              About ACCI
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold leading-[1.05] text-[#0E1112]">
              Experts in <span className="hl-box hl-cyan">holistic</span>,<br />
              culturally responsive<br />
              mental health.
            </h2>
            <p className="mt-6 text-neutral-700 leading-relaxed text-lg">
              ACCI has been nationally and internationally acknowledged as a leader in culturally responsive
              community mental health care and humanitarian-based approaches. Our model works for people
              regardless of heritage — which is why we now welcome any adult in the Black Country
              living with, or at risk of, mental ill health.
            </p>
            <p className="mt-4 text-neutral-700 leading-relaxed text-lg">
              Our approach is holistic and <strong>not time-bound</strong>, because healing does not follow a
              statutory timetable. We deliver the right support at the right time — for as long as it takes.
            </p>

            <div id="help" className="mt-10 border-t border-black/10">
              {services.map((s, i) => {
                const isOpen = open === i;
                return (
                  <div key={s.title} className="border-b border-black/10">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between py-5 text-left group"
                    >
                      <span className="font-serif text-xl lg:text-2xl font-semibold text-[#0E1112] group-hover:text-[#6e12ed] transition-colors">
                        {s.title}
                      </span>
                      <span
                        className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors flex-shrink-0 ${
                          isOpen ? 'bg-[#6e12ed] text-white' : 'bg-[#F0F8F8] text-[#5FADB0]'
                        }`}
                      >
                        {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                      </span>
                    </button>
                    <div
                      className="overflow-hidden transition-all duration-500 ease-out"
                      style={{ maxHeight: isOpen ? 200 : 0 }}
                    >
                      <p className="pb-5 pr-12 text-neutral-700 leading-relaxed">{s.text}</p>
                    </div>
                  </div>
                );
              })}
            </div>

            <a
              href="#stories"
              className="mt-8 inline-flex items-center gap-2 font-semibold text-[#6e12ed] link-underline"
            >
              Read our impact stories <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyStand;
